import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-prescricao-interna`
    const baseUrlFiltragem = `${baseUrl}/filtragem`

    return {
        index(queryParms) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        autocomplete(queryParms) {
            return repository.get(`${baseUrl}/autocomplete?${urlUtil.serialize(queryParms)}`)
        },
        filtragemPorUnidade(queryParms) {
            return repository.get(`${baseUrlFiltragem}/unidade?${urlUtil.serialize(queryParms)}`)
        },
        filtragemPorLocalAtendimento(queryParms) {
            return repository.get(`${baseUrlFiltragem}/local-atendimento?${urlUtil.serialize(queryParms)}`)
        },
        filtragemPorOcupacao(queryParms) {
            return repository.get(`${baseUrlFiltragem}/ocupacao?${urlUtil.serialize(queryParms)}`)
        },
        filtragemPorProfissional(queryParms) {
            return repository.get(`${baseUrlFiltragem}/profissional?${urlUtil.serialize(queryParms)}`)
        },
        filtragemPorMedicamento(queryParms) {
            return repository.get(`${baseUrlFiltragem}/medicamento?${urlUtil.serialize(queryParms)}`)
        },
        filtragemPorStatus(queryParms) {
            return repository.get(`${baseUrlFiltragem}/status?${urlUtil.serialize(queryParms)}`)
        },
    }
}